
import { MapLocation } from '@/types/location';

// Xfit Gym Locations
export const xfitGyms: MapLocation[] = [
  {
    id: 2001,
    name: "Xfit Gym - Riyadh (Shifa)",
    type: "Gym",
    devices: 3,
    coordinates: [24.573893099724202, 46.696866041280146],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "19-40",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 2002,
    name: "Xfit Gym - Riyadh (Rabie)",
    type: "Gym",
    devices: 3,
    coordinates: [24.796969143705102, 46.67622060489983],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "19-40",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 2003,
    name: "Xfit Gym - Riyadh (As Suwaidi)",
    type: "Gym",
    devices: 3,
    coordinates: [24.567019640694618, 46.64257648750352],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "19-40",
    orientation: "Landscape",
    segment: "Fitness"
  },
  {
    id: 2004,
    name: "Xfit Gym - Riyadh (Al Rabwa)",
    type: "Gym",
    devices: 3,
    coordinates: [24.693035086267287, 46.76666679694735],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Landscape Screens",
    gender: "Female",
    ageRange: "19-40",
    orientation: "Landscape",
    segment: "Fitness"
  }
];
